import { cn } from "@/modules/lib/utils"
import { ImageIcon } from "lucide-react"

export function ImageThumbnail({ url, className }: { url: string; className?: string }) {
  return (
    <>
      <div
        className={cn("h-full w-full bg-neutral-900/32 bg-cover bg-center bg-no-repeat bg-blend-multiply", className)}
        style={{
          backgroundImage: `url(${url})`,
        }}
      />
      <ImageIcon className="size-2xl center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-neutral-100" />
    </>
  )
}
